/* Generated File DO NOT EDIT. */
/* tslint:disable */
import * as Types from '../graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type LoginMutationVariables = Types.Exact<{
  input: Types.AuthInput;
}>;

export type LoginMutation = { __typename?: 'Mutation'; login: { __typename?: 'AuthResponse'; accessToken: string; refreshToken: string } };

export type RegisterMutationVariables = Types.Exact<{
  input: Types.RegisterInput;
}>;

export type RegisterMutation = { __typename?: 'Mutation'; register: { __typename?: 'AuthResponse'; accessToken: string; refreshToken: string } };

export type RefreshTokenMutationVariables = Types.Exact<{
  input: Types.RefreshTokenInput;
}>;

export type RefreshTokenMutation = { __typename?: 'Mutation'; refreshToken: { __typename?: 'AuthResponse'; accessToken: string; refreshToken: string } };

export type GenerateRegistrationOptionsQueryVariables = Types.Exact<{ [key: string]: never }>;

export type GenerateRegistrationOptionsQuery = { __typename?: 'Query'; generateRegistrationOptions: any };

export type VerifyRegistrationResponseMutationVariables = Types.Exact<{
  attResp: Types.Scalars['JSONObject'];
}>;

export type VerifyRegistrationResponseMutation = { __typename?: 'Mutation'; verifyRegistrationResponse: any };

export type GenerateAuthenticationOptionsQueryVariables = Types.Exact<{
  userId: Types.Scalars['String'];
}>;

export type GenerateAuthenticationOptionsQuery = { __typename?: 'Query'; generateAuthenticationOptions: any };

export type VerifyAuthenticationResponseMutationVariables = Types.Exact<{
  userId: Types.Scalars['String'];
  authResp: Types.Scalars['JSONObject'];
}>;

export type VerifyAuthenticationResponseMutation = {
  __typename?: 'Mutation';
  verifyAuthenticationResponse: { __typename?: 'AuthResponse'; accessToken: string; refreshToken: string };
};

export const LoginDocument = gql`
  mutation login($input: AuthInput!) {
    login(input: $input) {
      accessToken
      refreshToken
    }
  }
`;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
}
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const RegisterDocument = gql`
  mutation register($input: RegisterInput!) {
    register(input: $input) {
      accessToken
      refreshToken
    }
  }
`;
export type RegisterMutationFn = Apollo.MutationFunction<RegisterMutation, RegisterMutationVariables>;

/**
 * __useRegisterMutation__
 *
 * To run a mutation, you first call `useRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerMutation, { data, loading, error }] = useRegisterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterMutation(baseOptions?: Apollo.MutationHookOptions<RegisterMutation, RegisterMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RegisterMutation, RegisterMutationVariables>(RegisterDocument, options);
}
export type RegisterMutationHookResult = ReturnType<typeof useRegisterMutation>;
export type RegisterMutationResult = Apollo.MutationResult<RegisterMutation>;
export type RegisterMutationOptions = Apollo.BaseMutationOptions<RegisterMutation, RegisterMutationVariables>;
export const RefreshTokenDocument = gql`
  mutation refreshToken($input: RefreshTokenInput!) {
    refreshToken(input: $input) {
      accessToken
      refreshToken
    }
  }
`;
export type RefreshTokenMutationFn = Apollo.MutationFunction<RefreshTokenMutation, RefreshTokenMutationVariables>;

/**
 * __useRefreshTokenMutation__
 *
 * To run a mutation, you first call `useRefreshTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshTokenMutation, { data, loading, error }] = useRefreshTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRefreshTokenMutation(baseOptions?: Apollo.MutationHookOptions<RefreshTokenMutation, RefreshTokenMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RefreshTokenMutation, RefreshTokenMutationVariables>(RefreshTokenDocument, options);
}
export type RefreshTokenMutationHookResult = ReturnType<typeof useRefreshTokenMutation>;
export type RefreshTokenMutationResult = Apollo.MutationResult<RefreshTokenMutation>;
export type RefreshTokenMutationOptions = Apollo.BaseMutationOptions<RefreshTokenMutation, RefreshTokenMutationVariables>;
export const GenerateRegistrationOptionsDocument = gql`
  query generateRegistrationOptions {
    generateRegistrationOptions
  }
`;

/**
 * __useGenerateRegistrationOptionsQuery__
 *
 * To run a query within a React component, call `useGenerateRegistrationOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateRegistrationOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateRegistrationOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGenerateRegistrationOptionsQuery(baseOptions?: Apollo.QueryHookOptions<GenerateRegistrationOptionsQuery, GenerateRegistrationOptionsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GenerateRegistrationOptionsQuery, GenerateRegistrationOptionsQueryVariables>(GenerateRegistrationOptionsDocument, options);
}
export function useGenerateRegistrationOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenerateRegistrationOptionsQuery, GenerateRegistrationOptionsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GenerateRegistrationOptionsQuery, GenerateRegistrationOptionsQueryVariables>(GenerateRegistrationOptionsDocument, options);
}
export type GenerateRegistrationOptionsQueryHookResult = ReturnType<typeof useGenerateRegistrationOptionsQuery>;
export type GenerateRegistrationOptionsLazyQueryHookResult = ReturnType<typeof useGenerateRegistrationOptionsLazyQuery>;
export type GenerateRegistrationOptionsQueryResult = Apollo.QueryResult<GenerateRegistrationOptionsQuery, GenerateRegistrationOptionsQueryVariables>;
export const VerifyRegistrationResponseDocument = gql`
  mutation verifyRegistrationResponse($attResp: JSONObject!) {
    verifyRegistrationResponse(attResp: $attResp)
  }
`;
export type VerifyRegistrationResponseMutationFn = Apollo.MutationFunction<VerifyRegistrationResponseMutation, VerifyRegistrationResponseMutationVariables>;

/**
 * __useVerifyRegistrationResponseMutation__
 *
 * To run a mutation, you first call `useVerifyRegistrationResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyRegistrationResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyRegistrationResponseMutation, { data, loading, error }] = useVerifyRegistrationResponseMutation({
 *   variables: {
 *      attResp: // value for 'attResp'
 *   },
 * });
 */
export function useVerifyRegistrationResponseMutation(baseOptions?: Apollo.MutationHookOptions<VerifyRegistrationResponseMutation, VerifyRegistrationResponseMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<VerifyRegistrationResponseMutation, VerifyRegistrationResponseMutationVariables>(VerifyRegistrationResponseDocument, options);
}
export type VerifyRegistrationResponseMutationHookResult = ReturnType<typeof useVerifyRegistrationResponseMutation>;
export type VerifyRegistrationResponseMutationResult = Apollo.MutationResult<VerifyRegistrationResponseMutation>;
export type VerifyRegistrationResponseMutationOptions = Apollo.BaseMutationOptions<VerifyRegistrationResponseMutation, VerifyRegistrationResponseMutationVariables>;
export const GenerateAuthenticationOptionsDocument = gql`
  query generateAuthenticationOptions($userId: String!) {
    generateAuthenticationOptions(userId: $userId)
  }
`;

/**
 * __useGenerateAuthenticationOptionsQuery__
 *
 * To run a query within a React component, call `useGenerateAuthenticationOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateAuthenticationOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateAuthenticationOptionsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGenerateAuthenticationOptionsQuery(baseOptions: Apollo.QueryHookOptions<GenerateAuthenticationOptionsQuery, GenerateAuthenticationOptionsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GenerateAuthenticationOptionsQuery, GenerateAuthenticationOptionsQueryVariables>(GenerateAuthenticationOptionsDocument, options);
}
export function useGenerateAuthenticationOptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GenerateAuthenticationOptionsQuery, GenerateAuthenticationOptionsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GenerateAuthenticationOptionsQuery, GenerateAuthenticationOptionsQueryVariables>(GenerateAuthenticationOptionsDocument, options);
}
export type GenerateAuthenticationOptionsQueryHookResult = ReturnType<typeof useGenerateAuthenticationOptionsQuery>;
export type GenerateAuthenticationOptionsLazyQueryHookResult = ReturnType<typeof useGenerateAuthenticationOptionsLazyQuery>;
export type GenerateAuthenticationOptionsQueryResult = Apollo.QueryResult<GenerateAuthenticationOptionsQuery, GenerateAuthenticationOptionsQueryVariables>;
export const VerifyAuthenticationResponseDocument = gql`
  mutation verifyAuthenticationResponse($userId: String!, $authResp: JSONObject!) {
    verifyAuthenticationResponse(userId: $userId, authResp: $authResp) {
      accessToken
      refreshToken
    }
  }
`;
export type VerifyAuthenticationResponseMutationFn = Apollo.MutationFunction<VerifyAuthenticationResponseMutation, VerifyAuthenticationResponseMutationVariables>;

/**
 * __useVerifyAuthenticationResponseMutation__
 *
 * To run a mutation, you first call `useVerifyAuthenticationResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyAuthenticationResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyAuthenticationResponseMutation, { data, loading, error }] = useVerifyAuthenticationResponseMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      authResp: // value for 'authResp'
 *   },
 * });
 */
export function useVerifyAuthenticationResponseMutation(
  baseOptions?: Apollo.MutationHookOptions<VerifyAuthenticationResponseMutation, VerifyAuthenticationResponseMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<VerifyAuthenticationResponseMutation, VerifyAuthenticationResponseMutationVariables>(VerifyAuthenticationResponseDocument, options);
}
export type VerifyAuthenticationResponseMutationHookResult = ReturnType<typeof useVerifyAuthenticationResponseMutation>;
export type VerifyAuthenticationResponseMutationResult = Apollo.MutationResult<VerifyAuthenticationResponseMutation>;
export type VerifyAuthenticationResponseMutationOptions = Apollo.BaseMutationOptions<VerifyAuthenticationResponseMutation, VerifyAuthenticationResponseMutationVariables>;
